import React from 'react';
import { Grid } from 'semantic-ui-react';
import CatalogueTitle from './CatalogueTitle';
import CataloguePanelContainer from './CataloguePanelContainer';
import DatasetSubscribeAction from '../../subscriptions/components/DatasetSubscribeAction';
import DatasetVisibilityLabel from '../../components/DatasetVisibilityLabel';
import DatasetCatalogue from './DatasetCatalogue';
import Selectors from '../hooks/selectors';

const CataloguePanelFull = ({ category, code, onChange }) => {
  const state = Selectors.useCataloguePanel({ category, code });
  return (
    <CataloguePanelContainer
      category={category}
      className="aridhia-catalogue-panel-full"
      code={state.code}
      onChange={onChange}
    >
      <Grid>
        <Grid.Row columns="equal">
          <Grid.Column>
            <CatalogueTitle code={state.code} category={category} />
          </Grid.Column>
          <Grid.Column width={3} floated="right" textAlign="right" className="min-w-230">
            <DatasetVisibilityLabel visibility={state.visibility} code={state.code} allowManage={state.allowManage} />
            {state.canSubscribe && <DatasetSubscribeAction code={state.code} category={category} />}
          </Grid.Column>
        </Grid.Row>
        <DatasetCatalogue category={category} code={state.code} url={state.url} />
      </Grid>
    </CataloguePanelContainer>
  );
};

export default CataloguePanelFull;
